import type { Chart, Plugin } from 'chart.js';

type ChartWithResizeHandle = Chart & {
    _doResize?: { clear?: () => void };
};

function isChartCanvasAttached(chart: Chart): boolean {
    const canvas = chart.canvas;
    return canvas != null && canvas.isConnected;
}

/**
 * Chart.js 4.4.x can fire its debounced resize/update after React has unmounted
 * the canvas (`this.canvas` is null, then `_getParentNode` reads `parentNode`).
 * Cancel that update and clear the resize handle on destroy.
 */
const skipDetachedCanvasPlugin: Plugin = {
    id: 'skipDetachedCanvas',
    beforeUpdate(chart) {
        if (!isChartCanvasAttached(chart)) {
            return false;
        }
        return undefined;
    },
    beforeDestroy(chart) {
        chart.stop();
        const doResize = (chart as ChartWithResizeHandle)._doResize;
        doResize?.clear?.();
    },
};

export default skipDetachedCanvasPlugin;
